export enum ServiceTaskTypeEnum {
  Pickup = 'Delivery',
  Dropoff = 'Delivery',
  Operation = 'Operation'
}
